import { APP_INITIALIZER, ErrorHandler, NgModule, inject } from "@angular/core";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {
    AddOnService,
    AgentsAndCoverageService,
    AppService,
    AuthService,
    CustomerService,
    OffersQuestionsAnswersService,
    PackageService,
    ProductsService,
    RolesAndPermissionsService,
    TicketsAndComplaintService,
    TmsQueueService,
    
} from "./services";
import {
    AppData,
    AuthData,
    OrdersData,
    CustomerData,
    ProductsData,
    rolesAndRightsService,
    AddOnsData,
    TmsData,
    PackagesData,
    OffersQuestionsAndAnswersData,
    TicketsAndComplaintsData,
    UserServiceData,
    AgentsAndCoverageAreaDataService,
} from "./data";
import { JwtModule } from "@auth0/angular-jwt";
import { ApiInterceptor } from "./api.interceptor";
import { OrdersService } from "./services/selfcare/orders.service";
import { LastActiveService } from "./services/user-activity/last-active.service";
import { GlobalErrorHandler } from "./globalErrorHandler";
import { SalesData } from "./data/sales/sales-data";
import { SalesService } from "./services/sales/sales.service";
import { BannersDataService } from "./data/admin/bannerData";
import { BannersService } from "./services/admin/promotional-banners-service/banners.service";
import { LocalStorageService } from "./services/shared-services/local-storage.service";
import { CustomerServiceData } from "./data/admin/customers-data";
import { CustomersService } from "./services/admin/customer-service/customers.service";
import { UsersService } from "./services/user-service/users.service";
import { CustomCurrencyPipe } from "../shared/pipe/currency.pipe";
import { HelpAndSupport } from "./data/admin/help-and-support-data";
import { HelpAndSupportService } from "./services/admin/help-and-support.service";
import { CartService } from "./services/shared-services/cart.service";
import { AppTimeService } from "./services/shared-services/app-time.service";
import { notificationData } from "./data/notifications-data";
import { NotificationService } from "./services/shared-services/notification/notification.service";
import { EncryptionInterceptor } from "./encryption.interceptor";
import { BundlesCongfigurationdata } from "./data/admin/bundles-configuration-data";
import { BundlesService } from "./services/admin/bundles-configuration-service/bundles-configuration-service";
import { SelfCareDashboardService } from "./services/selfcare/dashboard/selfcareDashboardService";
import { SelfCareData } from "./data/selfcare/dashboard/selfcareData";
import { GroupsService } from "./services/selfcare/groups.service";
import { GroupsData } from "./data/selfcare/groupsData";

@NgModule({ declarations: [CustomCurrencyPipe], imports: [CommonModule, JwtModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: EncryptionInterceptor,
            multi: true,
        },
        { provide: AuthData, useClass: AuthService },
        { provide: ProductsData, useClass: ProductsService },
        { provide: AppData, useClass: AppService },
        { provide: CustomerData, useClass: CustomerService },
        {
            provide: rolesAndRightsService,
            useClass: RolesAndPermissionsService,
        },
        { provide: ProductsData, useClass: ProductsService },
        { provide: SalesData, useClass: SalesService },
        { provide: OrdersData, useClass: OrdersService },
        { provide: HelpAndSupport, useClass: HelpAndSupportService },
        { provide: AddOnsData, useClass: AddOnService },
        { provide: BundlesCongfigurationdata, useClass: BundlesService },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        { provide: TmsData, useClass: TmsQueueService },
        { provide: BannersDataService, useClass: BannersService },
        { provide: PackagesData, useClass: PackageService },
        { provide: notificationData, useClass: NotificationService },
        { provide: AgentsAndCoverageAreaDataService, useClass: AgentsAndCoverageService },
        {
            provide: OffersQuestionsAndAnswersData,
            useClass: OffersQuestionsAnswersService,
        },
        {
            provide: TicketsAndComplaintsData,
            useClass: TicketsAndComplaintService,
        },
        { provide: CustomerServiceData, useClass: CustomersService },
        { provide: UserServiceData, useClass: UsersService },
        {
            provide: APP_INITIALIZER,
            multi: true,
            deps: [AuthService],
            useFactory: (loginService: AuthService) => () =>
                loginService.setUp(),
        },
        { provide: SelfCareData ,useClass: SelfCareDashboardService},
        { provide: GroupsData, useClass: GroupsService },
        LastActiveService,
        LocalStorageService,
        CartService,
        AppTimeService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule {}
